<div [class.video-preview]="isVideo" class="media-file">
  <img *ngIf="!isPDF" [class]="class" [src]="url">
  <img *ngIf="isPDF" class="pdf" src="assets/icons/media_types/pdf.svg">
</div>
